<template>
  <div class="session-banner">
    <v-container px-0>
      <v-layout row wrap>
        <v-flex xs12 sm10 md6 lg5 mx-auto mb-70>
          <div class="mb-70">
            <router-link to="/" class="d-block text-xs-center"><img src="/static/img/session-logo.png" /><h3 style="color:white;">生活、学习点滴记录</h3></router-link></p>
          </div>
          <div class="session-block">
            <div class="session-head text-xs-center">
              <div class="div-icon mb-3">
                <i class="ti-lock font-2x"></i>
              </div>
              <h3 class="mb-4">{{session_info[login_step].h1}}</h3>
              <p class="fs-14 px-5">{{session_info[login_step].h2}}</p>
            </div>
            <v-form v-model="valid" class="mb-4" ref="form">
              <v-text-field @keyup.13="$refs['password'].focus()"  ref="id" :label="session_info[login_step].f1.lable" v-model="id" :rules="session_info[login_step].f1.rules" required></v-text-field>
              <v-text-field @keyup.13="submit" ref="password" :label="session_info[login_step].f2.lable" v-model="password" type="password" :rules="session_info[login_step].f2.rules" required></v-text-field>
              <v-btn @click="submit" block class="btn-gradient-primary">登录</v-btn>
            </v-form>
          </div>
          
        </v-flex>
      </v-layout>

      <v-flex xs12 sm10 md6 lg5 mx-auto>
          <div class="mb-70">
            <h3 style="color:white;display: flex;justify-content: center;">
              <a style="color:white;" href="https://beian.miit.gov.cn/">湘ICP备16002252号-1</a>
            </h3>
          </div>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import { mapGetters ,mapMutations} from 'vuex'
import {setToken } from '@/lib/auth' // getToken from cookie

export default {
  computed:{
     ...mapGetters({shop_info:'shop_info'}),
     login_step(){
        return this.shop_info?1:0;
     }
  },
  data() {
    return {
      checkbox: false,
      valid: false,
      id: "",
      password: "",
      session_info:[{
         h1:'>用户登录<',
         h2:'请输入用户号及密码',
         f1:{
              lable:'用户号',
              rules:[v => !!v || "用户号是必须的"],
         },
         f2:{
              lable:'密码',
              rules:[v => !!v|| "密码是必需的"],
         }
      },{
         h1:'用户登录',
         h2:'请输入用户名及密码',
         f1:{
              lable:'用户名/手机号',
              rules:[
              v => !!v || "用户是必须的",
              v => /^1[345789]\d{9}$/.test(v) || "用户名格式不正确"
            ],
         },
         f2:{
              lable:'密码',
              rules:[v => !!v|| "密码是必需的"],
         }
      }]

    };
  },
  methods: {
    submit() {
      	console.log("Login");
      	let ok = this.$refs.form.validate();
      	if(!ok) return this.$notify({group: 'msgpad', type: 'error', title: '输入错误', text: '输入的信息有误！'});
    	if(this.login_step ==0) this.shop_login();
    	else this.user_login();
    },
    shop_login(){
  		this.$store.dispatch('act_look_shop_info',{
				shop_id   :this.id, 
				sec_key   :this.password,
  		}).then(info=>{
  			// debugger
  			this.$store.commit('MUTATIONS_SHOP_SHOP_INFO',info);
  			this.$notify({group: 'msgpad', type: 'success', title: '成功', text: '店铺设置成功'});
  			this.id = this.password = '';
  		}).catch(err=>{
  			debugger
  			let msg = (err.response&&err.response.data)?err.response.data:err.message;
  			this.$notify({group: 'msgpad', type: 'error', title: '系统错误', text: '登陆错误'});
  		})
    },
    user_login(){
    	let self = this;
  		self.$store.dispatch('act_worker_login',{
				shop_id  :self.shop_info.shop_id,
				sec_key  :self.shop_info.sec_key,
				worker_id  :self.id,
				password :self.password
  		}).then(user_info=>{
  			self.$store.commit('NAVBAR_USER_USER_INFO',user_info);
  			self.$notify({group: 'msgpad', type: 'success', title: '成功', text: '登陆成功'});
  			self.id = self.password = '';
  			setToken(user_info._id);
  			self.$router.push('/')
  		}).catch(err=>{
  			debugger
  			let msg = err.data?err.data:'';
  			msg = msg?msg:((err.response&&err.response.data)?err.response.data:err.message);
  			self.$notify({group: 'msgpad', type: 'error', title: '系统错误', text: msg});
  		})
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/session/Login.vue